import React, {Component} from "react";
import {route} from "../../vars/rd";

class NotFoundOther extends Component {

    constructor(props) {
        super(props);
        route('/404.not.found');
    }

    render() {
        return (
            <div>
                404 not found
            </div>
        );
    }
}

export default NotFoundOther;


// WEBPACK FOOTER //
// ./src/pages/error/not.found.other.jsx